import { useStore } from 'vuex'
import * as echarts from 'echarts'
import * as settings from '@/settings'
import message from '@/libs/message'
import * as util from '@/libs/util.js'
import storage from '@/libs/storage'
import * as Components from '@/components/index'
import { VAceEditor } from 'vue3-ace-editor'
import 'ace-builds/src-noconflict/theme-chrome'
import 'ace-builds/src-noconflict/mode-php'
import 'ace-builds/src-noconflict/mode-html'
import 'ace-builds/src-noconflict/mode-xml'
import 'ace-builds/src-noconflict/mode-css'
import 'ace-builds/src-noconflict/mode-javascript'
import 'ace-builds/src-noconflict/mode-typescript'
import 'ace-builds/src-noconflict/mode-json'
import 'ace-builds/src-noconflict/mode-text'
import 'ace-builds/src-noconflict/mode-jsp'
import 'ace-builds/src-noconflict/mode-yaml'
import 'ace-builds/src-noconflict/mode-csharp'  // .net
import 'ace-builds/src-noconflict/mode-java'
import 'ace-builds/src-noconflict/mode-jade'
import 'ace-builds/src-noconflict/mode-jsx'
import 'ace-builds/src-noconflict/mode-markdown'
import 'ace-builds/src-noconflict/mode-pgsql'
import 'ace-builds/src-noconflict/mode-ini'


const mergetUtils = (util) => {
  return Object.assign((Xinnet.util || {}), util)
}

const regMethod = () => {
  const files = require.context('./hooks', false, /\.ts$/)
  Xinnet.hooks = files.keys().reduce((modules, path) => {
    let name = path.replace(/^\.\/(.*)\.\w+$/, '$1')
    const names = name.split('/')
    name = names[names.length - 1]
    const value = files(path)
    modules[name] = value.default
    return modules
  }, {})
  
  
  Xinnet.message = message
  Xinnet.util = mergetUtils(util)
  Xinnet.echarts = echarts
  Xinnet.settings = settings
  Xinnet.storage = storage
  
  // 存储全部枚举
  // Object.keys(settings).forEach((key: string) => {
  //   if (key.includes('Opts') && !storage.get(key)) {
  //     storage.set(key, JSON.stringify(settings[key]))
  //   }
  // })
}

const regComponent = (app) => {
  app.component('VAceEditor', VAceEditor)
  Object.keys(Components).forEach((key) => {
    const comp = Components[key]
    const compName = comp.__name.at(0).toUpperCase() + comp.__name.slice(1)
    app.component('Xn' + compName, comp)
  })

  importIcons()
}

const importIcons = () => {
  const req = require.context('./assets/icons', false, /\.svg$/)
  const importAll = (requireContext) => {
    requireContext.keys().map((file) => {
      requireContext(file)
    })
  }
  importAll(req)
}

const regGlobalProperties = (app) => {
  app.config.globalProperties.$settings = settings
  app.config.globalProperties.$util = mergetUtils(util)

  app.config.globalProperties.$onCopy = () => {
    Xinnet.message.success('复制成功')
  }
  app.config.globalProperties.$defaultTime = [
    new Date(2000, 1, 1, 0, 0, 0),
    new Date(2000, 2, 1, 23, 59, 59),
  ]
  app.config.globalProperties.$auth = (roles) => {
    const role = useStore().state?.hostInfo?.operatorType
    if (roles?.length && role) {
      return roles.includes(role)
    }
    return false
  }
  // Popup Container
  app.config.globalProperties.$container = () => {
    return document.querySelector('.xn-content')
  }
}

export {
  regMethod,
  regComponent,
  regGlobalProperties,
}
